export default class NotificationChannel {
    public id: string;
    public name: string;
    public channelTypeId: string;
    public createdOn: string;
    public updatedOn: string;
};



// WEBPACK FOOTER //
// ./src/modules/organization/models/NotificationChannel.ts